import React, { useState, useEffect } from "react";

const CountdownBanner = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [showCountdown, setShowCountdown] = useState(false);

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();

      const lastDayOfMonth = new Date(year, month + 1, 0).getDate();

      const endDate = new Date(year, month + 1, 0, 23, 59, 59);

      const isWithinLastTenDays = now.getDate() >= lastDayOfMonth - 9;
      const difference = endDate - now;

      const shouldShow = isWithinLastTenDays && difference > 0;

      setShowCountdown(shouldShow);

      if (shouldShow) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
      }
    };

    updateCountdown();

    const timerId = setInterval(updateCountdown, 1000);

    return () => clearInterval(timerId);
  }, []);

  return (
    <div className="relative">
      <div className="bg-gradient-to-r from-red-600 to-red-800 text-white py-1 px-4 sm:px-6 text-center shadow-lg">
        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6">
          <div className="flex items-center">
            <p className="text-sm sm:text-base md:text-md font-bold">
              {showCountdown
                ? "Get 20% off all NVQs and up to 30% off on select CITB courses - Limited Slots Left!"
                : "30% Discount on select CITB Courses. Slots are filling Fast, Enrol Now!"}
            </p>
          </div>

          {/* {showCountdown && (
            <div className="hidden md:flex items-center gap-1 sm:gap-2">
              <div className="bg-red-900 px-2 py-1 rounded-lg flex items-center">
                <span className="mr-1">⏰</span>
                <span className="text-xs sm:text-sm font-semibold">
                  HURRY UP!
                </span>
              </div>

              <div className="flex items-center bg-red-900 bg-opacity-80 text-white px-3 py-1 rounded-full">
                <div className="flex space-x-1 sm:space-x-2">
                  <TimeUnit value={timeLeft.days} label="DAYS" />
                  <div className="font-bold">:</div>
                  <TimeUnit value={timeLeft.hours} label="HRS" />
                  <div className="font-bold">:</div>
                  <TimeUnit value={timeLeft.minutes} label="MIN" />
                  <div className="font-bold">:</div>
                  <TimeUnit value={timeLeft.seconds} label="SEC" />
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

const TimeUnit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <span className="text-xs sm:text-sm md:text-base font-bold min-w-[30px] text-center">
      {value.toString().padStart(2, "0")}
    </span>
    <span className="text-[0.6rem] sm:text-xs opacity-80">{label}</span>
  </div>
);

export default CountdownBanner;
